export default __webpack_public_path__ + "static/media/profile2.f7f66837.png";